import { ReactChild } from "react";
import { ThemeProvider, createGlobalStyle } from "styled-components";
import { theme } from "kosmos-ui";

const GlobalStyle = createGlobalStyle`
  b {
    font-weight: ${theme.fontWeights.bold};
  }
`;

export default function ThemeContextProvider({
  children,
}: {
  children: ReactChild;
}) {
  return (
    <ThemeProvider theme={theme}>
      <>
        <GlobalStyle />

        {children}
      </>
    </ThemeProvider>
  );
}
